var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityStore, QueryEntity, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
var EnrollmentOverviewStore = /** @class */ (function (_super) {
    __extends(EnrollmentOverviewStore, _super);
    function EnrollmentOverviewStore() {
        return _super.call(this, { size: 25, pageIndex: 0, total: 0 }) || this;
    }
    EnrollmentOverviewStore.prototype.upsertPage = function (courseEnrollments, size, pageIndex, total) {
        var _this = this;
        var courseEnrollmentIds = courseEnrollments
            .map(function (enrollment) {
            _this.upsert(enrollment.id, enrollment);
            return enrollment.id;
        });
        this.updateRoot({
            size: size,
            pageIndex: pageIndex,
            total: total,
            pageIds: courseEnrollmentIds
        });
    };
    EnrollmentOverviewStore = __decorate([
        StoreConfig({ name: 'enrollmentOverview' }),
        __metadata("design:paramtypes", [])
    ], EnrollmentOverviewStore);
    return EnrollmentOverviewStore;
}(EntityStore));
export { EnrollmentOverviewStore };
var EnrollmentOverviewQuery = /** @class */ (function (_super) {
    __extends(EnrollmentOverviewQuery, _super);
    function EnrollmentOverviewQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        return _this;
    }
    EnrollmentOverviewQuery.prototype.getPageIndex = function () {
        return this.getSnapshot().pageIndex;
    };
    EnrollmentOverviewQuery.prototype.getSize = function () {
        return this.getSnapshot().size;
    };
    EnrollmentOverviewQuery.prototype.getTotal = function () {
        return this.getSnapshot().total;
    };
    EnrollmentOverviewQuery.prototype.selectPageIndex = function () {
        return this.select(function (state) { return state.pageIndex; });
    };
    EnrollmentOverviewQuery.prototype.selectSize = function () {
        return this.select(function (state) { return state.size; });
    };
    EnrollmentOverviewQuery.prototype.selectTotal = function () {
        return this.select(function (state) { return state.total; });
    };
    EnrollmentOverviewQuery.prototype.selectPage = function () {
        var _this = this;
        return this.select(function (state) { return state.pageIds.map(function (id) { return _this.getEntity(id); }); });
    };
    EnrollmentOverviewQuery.ngInjectableDef = i0.defineInjectable({ factory: function EnrollmentOverviewQuery_Factory() { return new EnrollmentOverviewQuery(i0.inject(EnrollmentOverviewStore)); }, token: EnrollmentOverviewQuery, providedIn: "root" });
    return EnrollmentOverviewQuery;
}(QueryEntity));
export { EnrollmentOverviewQuery };
